import React, { useState } from 'react';

import { BackgroundTasksTray as MarbleTray } from '@components/marble/BackgroundTasksTray';

import { useTrayDisplayTasks } from './trayActions';
import useBackgroundTasks from './useBackgroundTasks';

const BackgroundTasksTray: React.FC = () => {
  const { tasks, dismissTask } = useBackgroundTasks();
  const [expanded, setExpanded] = useState(false);
  const displayTasks = useTrayDisplayTasks(tasks);

  return (
    <MarbleTray
      tasks={displayTasks}
      expanded={expanded}
      onToggle={() => setExpanded((v) => !v)}
      onDismissTask={dismissTask}
    />
  );
};

export default BackgroundTasksTray;
